
import { Injectable } from '@angular/core';
import { EncoreConfiguration } from '../configuration/encore-configuration.model';

@Injectable()
export class EncoreService{

    private static jwt: string;

    public static isScriptLoaded: boolean = false;

    public static get isEnabled(): boolean{
      return this.configuration.isEnabled.toString() == "true";
    }

    public static configuration: EncoreConfiguration= new EncoreConfiguration();

    private static encore: any;

    constructor(){}

    static initialize(configuration:EncoreConfiguration){
      this.configuration = configuration;
      if(this.isEnabled){
        this.load(configuration.jsUrl);
        this.linkCss(configuration.cssUrl);
      }
    }

    static initForAgent(jwt:string){
      if(this.isEnabled) {
      this.encore = window["encore"];
      this.encore.init(jwt);
      }
    }

    static pause(){
     if(this.isEnabled) {
      this.encore.pause();
      }
    }

    static resume(){
      if(this.isEnabled) {
      this.encore.resume();
      }
    }
    
    private static load(sourceUrl:string){
        this.getScript(sourceUrl, function(){
            this.isScriptLoaded = true;
            console.log("EnoreJs...Loaded");
        })
    }

    private static linkCss(src:string, callback?:Function){
      let d = document;

      let o = { callback: callback || function(){} };
  
      let s, t;
  
      if ( typeof src == "undefined" ) {
        return;
      }
      var head  = document.getElementsByTagName('head')[0];

      s = d.createElement("LINK");
      s.setAttribute("rel","stylesheet");
      s.setAttribute("type","text/css");
      s.setAttribute("href",src);
  
      if ( typeof o.callback == "function" ) {
  
        if ( d.addEventListener ) {
  
          s.addEventListener("load",function(){o.callback()},false);
  
        } else {
  
          // old IE support
  
          s.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded"){this.onreadystatechange=null;o.callback()}};
  
        }
  
      }
  
      //t = d.getElementsByTagName("link")[0];
      head.appendChild(s);
      //t.parentNode.insertBefore(s, t);
  
    }
    private static getScript( src : string, callback : Function ) {

    let d = document;

    let o = { callback: callback || function(){} };

    let s, t;

    if ( typeof src == "undefined" ) {
      return;
    }
    
    s = d.createElement("script");s.language="javascript";s.type="text/javascript";s.async=1;s.charset="utf-8";s.src=src;

    if ( typeof o.callback == "function" ) {

      if ( d.addEventListener ) {

        s.addEventListener("load",function(){o.callback()},false);

      } else {

        // old IE support

        s.onreadystatechange=function(){if(this.readyState=="complete"||this.readyState=="loaded"){this.onreadystatechange=null;o.callback()}};

      }

    }

    t = d.getElementsByTagName("script")[1];

    t.parentNode.insertBefore(s, t);

  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/encore.service.ts